import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { ResultType } from 'Types/common';

const FlexLiteInfoToPay = ({ data }: { data: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  return (
    <>
      <Text type="paragraphs" align="center" size="L_XL_S" color="dark">
        {t('Flex.lite.toPay.header')}
      </Text>
      <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
        <Text type="paragraphs" align="center" size="M_L_S" color="dark">
          {t('Flex.lite.toPay.subheader', {
            amount: YayoyakiFormatter.formatAmountMxn(Math.abs(data?.taxReturnResult)),
          })}
        </Text>
        <Text type="paragraphs" size="XS_M_S" color="grey">
          {t('Flex.lite.toPay.info')}
        </Text>
      </FlexContainer>
    </>
  );
};

export default FlexLiteInfoToPay;
